export const errorCode = {
  A0400: '数据异常,请联系管理员',
  A0410: '缺少必要参数',
  B0001: 'System Error',
  A1001: '分类名称已经存在',
  A1002: '主题名称已经存在',
  A1003: '已经跟运营方案绑定，不允许删除',
  A1004: '主品牌名字已经存在',
  A1005: '子品牌名字已经存在',
  A2001: '运营方案名称已经存在',
  A2002: '运营方案不允许删',
  V1001: '已存在运行中的方案',
  V1011: '子推荐区域已经存在',
  B0002: '导入的文件为空,请按下载文档校正再导入',
  B0003: '导入的表头信息错误,请按下载文档校正再导入',
  B0004: 'excel文件里面的数据项错误,请按下载文档校正再导入',
  V5001: '调用翻译接口失败',
  V5002: '该信息源ID不存在,请新增影片',
  A0501: '上传队列已满',
  A10001: '密钥，桶，或者区域填写错误',
  A10002: '模板名重复',
  A10003: '服务器名重复',
  A10004: '模板类型错误',
  A10005: '该批量文件已转码',
  A10006: '无权创建桶',
  A10007: 'cloudfront 输入错误',
  A10008: '路径或者服务名重复',
  A20001: '文件无需转码',
  A20002: '非视频文件',
  'mp-505': '盒子离线',
  B0005: 'SN有误请修改后再提交',
  B0006: '验证码有误请修改后再提交',
  V5003: '修改排序号重复',
  I1009: '请求频繁',
  1006: '配置已重复，请修改后提交',
  1008: 'SN无效',
  C0001: '已存在',
  C0002: '请勿重复添加数据(PID、CID)'
}